import { Helmet } from 'react-helmet-async';
import { TITLES } from '../../types/titles';
import SetupTwoFaLayout from '../../components/auth/setup-two-fa';

const LoginSetupTwoFa = () => {
	return (
		<>
			<Helmet>
				<title>{TITLES.AUTH.SETUP}</title>
			</Helmet>
			<SetupTwoFaLayout />
		</>
	);
};

export default LoginSetupTwoFa;
